import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import multiFilteredObjectsSelector from 'functions/multiFilteredObjectsSelector'
import { objectsToArray, sortArrayBy } from 'functions/utilities'

class ReviewsWrapper extends React.Component {
  render(){
    const { campaigns, reviews, render } = this.props

    const array = objectsToArray(reviews)
    const sorted = sortArrayBy(array, 'desc', 'rating')

    if (!sorted.length) return null

    return render({
      campaigns,
      reviews: sorted,
    })
  }
}

ReviewsWrapper.propTypes = {
  campaigns: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
  reviews: PropTypes.object.isRequired,
}

function mapStateToProps(state, props){
  const { agent = {} } = props
  const { campaigns } = state.entities

  return {
    campaigns,
    reviews: multiFilteredObjectsSelector(state, 'reviews', [
      { key: 'recipient_type', value: 'Agent' },
      { key: 'recipient_id', value: agent.id },
    ]),
  }
}

export default connect(mapStateToProps)(ReviewsWrapper)
